(ns basic-components.field-cell-editor
  (:require
   [common.localization :as loc]
   [frontend.utils :as fu]
   [basic-components.inputs.footprint :refer [editor viewer display-string]]
   [frontend.dom-utils :as dom-utils]
   [clojure.string :as string]
   [frontend.logging :as logging]
   [reagent.core :as r]
   [reagent.dom :as rd]))

(defn resolve-editor-type
  [view-args]
  (let [editor-type (or (:editor/type view-args)
                        (:editor/type (:field view-args)))]
    (if-not editor-type
      (logging/error "Editor type not found : " view-args)
      editor-type)))

(defn clear-focus!
  [state]
  (swap! state dissoc
    :focused-cell-col
    :focused-cell-row
    :focus?
    :has-focus?))

(defn render
  [local-atom editor-atom
   {:keys [id
           entity-type
           entity-unique-name
           value
           state-atom
           attribute label hide-label?
           on-save!
           on-cancel-edit!
           on-key-down!
           ref-atom
           class-name
           mandatory? drag-options
           source-options validate!
           disabled? read-only?
           show-tooltip-right?
           info-text
           error-text
           tools secondary-view-args]
    :as   view-args}]
  (when-not attribute
    (logging/error "NO Attribute : " view-args))
  (let [editor-dom-node (:editor-dom-node @editor-atom)
        has-focus? (:has-focus? @state-atom)
        secondary-attribute (:attribute secondary-view-args)
        on-input-focus! (fn [e]
                          (swap! state-atom assoc :has-focus? true)
                          true)
        on-input-change! (fn [e edit-value]
                           (if (= edit-value value)
                             (swap! local-atom dissoc :has-updates?)
                             (swap! local-atom assoc :has-updates? true))
                           (swap! local-atom assoc :editor-value edit-value)
                           (when validate!
                             (let [error-text (validate! attribute edit-value)]
                               (if error-text
                                 (do
                                   ;(logging/error "Field editor error on-input-change!: " error-text " << " edit-value)
                                   (swap! state-atom assoc :error error-text))
                                 (swap! state-atom dissoc :error))))
                           true)
        on-input-blur!
        (fn [blurred-attribute e value-on-blur clear-temp-cb]
          (let [related-target (some-> e
                                       .-relatedTarget)
                value-on-blur (if (string? value-on-blur)
                                (string/trim value-on-blur)
                                value-on-blur)
                field-args (if (= blurred-attribute secondary-attribute)
                             secondary-view-args
                             view-args)
                clear? (or (nil? value-on-blur)
                           (and (string? value-on-blur)
                                (empty? (string/trim value-on-blur))))]
            (if (and clear? (:field/not-clearable? field-args)) ;; if value must not be cleared - error msg
              (do
                (swap! state-atom dissoc :has-focus?)
                (swap! state-atom assoc :error (loc/tr :value-cannot-be-cleared)))
              (do
                (if-not related-target
                  (swap! state-atom dissoc :has-focus?)
                  (when-not (dom-utils/is-ancestor? related-target editor-dom-node)
                    (swap! state-atom dissoc :has-focus?)))
                (when (fn? on-save!)
                  (let [error-text (when validate! (validate! blurred-attribute value-on-blur))]
                    ;; timeout for clearing internal state ? or do we handle this outside ?
                    ;; on success
                    ;; must also think about error messages !!!
                    (if error-text
                      (logging/error "Field editor error on-input-blur!: " error-text
                                     " << " value-on-blur)
                      (on-save!
                       blurred-attribute
                       value-on-blur
                       (fn [_]
                         (swap! state-atom dissoc :error)
                         (when clear-temp-cb
                           (swap! local-atom dissoc :has-updates? :editor-value)
                           (clear-temp-cb))
                         (when on-cancel-edit!
                           (on-cancel-edit!))) ;; clear temp state
                       (fn [err]
                         (let [error-msg (:message err)]
                           (logging/error "ERROR saving value : " error-msg " " value-on-blur)
                           (when error-msg
                             (swap! state-atom assoc :error (str error-msg))))
                         ;; TODO: error handling - do not reset temp state -> or user would lose temp data on error
                       )))))))))

        error (:error @state-atom)
        error-text-secondary (:error-text-secondary secondary-view-args)
        error-text (or error error-text-secondary)
        {:keys [:source-icon-fn]} source-options
        primary-editor-type (resolve-editor-type view-args)]
    [:div
     {:ref        (fn [e]
                    (when e
                      ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                      ;; events withing this editor if needed
                      (swap! editor-atom assoc :editor-dom-node e)))
      :class-name (fu/cs (str "input-editor-class__"
                              (when (keyword? entity-type)
                                (name entity-type))
                              "__" (when (keyword? attribute)
                                     (namespace attribute))
                              "_" (when (keyword? attribute)
                                    (name attribute)))
                         (when (keyword? attribute)
                           (str (namespace attribute) "_" (name attribute)))
                         (str
                          "entity-name-class__"
                          (string/replace (str entity-unique-name)
                                          #"\s"
                                          ""))

                         "input-editor"
                         (when has-focus? "input-editor--focused")
                         (when class-name class-name))}
     [:div.input-editor__content
      [:div.input-editor__input
       (if read-only?
         [viewer view-args]
         [:div.input-editor__primary-content
          [editor
           (merge
            view-args
            {:editor/type            primary-editor-type
             :state-atom             state-atom
             :unique-id              entity-unique-name
             :debug?                 (:debug? @editor-atom)
             :has-focus?             has-focus?
             :on-key-down!           (fn [e]
                                       (let [key-code (.-keyCode e)
                                             grid-ref (:grid-ref @ref-atom)]
                                         (when (= key-code 27) ;; ESC -> set temp value as old value
                                           (when-let [cancel-edit! (:cancel-edit! @editor-atom)]
                                             (cancel-edit!))
                                           (.focus grid-ref))
                                         (when (= key-code 13)
                                           (when-let [save! (:save! @editor-atom)]
                                             (save!))
                                           (.focus grid-ref))
                                         (.stopPropagation e)))
             :class-name             (fu/cs (when error-text "error")
                                            (when read-only? "readonly")
                                            (when disabled? "disabled")
                                            (when (and secondary-attribute secondary-view-args)
                                              "primary-input"))
             :set-focusable-element! (fn [e]
                                       (swap! editor-atom assoc :set-focusable-element! e))
             :set-cancel-edit!       (fn [e]
                                       (swap! editor-atom assoc :cancel-edit! e))
             :set-save!              (fn [e]
                                       (swap! editor-atom assoc :save! e))
             :on-change!             on-input-change!
             :on-error!              (fn [error-text]
                                       (swap! state-atom assoc :error error-text))
             :clear-error!           (fn []
                                       (swap! state-atom dissoc :error))
             :on-focus!              on-input-focus!
             :cursor-at-end-on-focus? true
             :on-blur!               (partial on-input-blur! attribute)
             :auto-focus             true})]])]]]))

(defn view
  [{:keys [editor/type         ;; this is used by the multimethod to dispatch to correct input implementation
           value               ;; controlled element -> you must control the rendered value outside of the editor -> use state-atom to store value or directly to back end entity
           state-atom          ;; main state where we store all information about hover, focused, active cells and errors
           attribute           ;; this is and identifier for the edited input -> it can be a custom attribute for the view or it can be an entity field :email / :oppo/name ...
           on-save!            ;; this is used for notifying containing logic of end of edit -> change state outside and make sure to update the value param -> controlled state
           label               ;; visible label for input element - f.e. "Name" (loc/tr :oppo/name)
           options             ;; optional - select editor options list [{:key :option-1 :label "Option1"} {:key 123031023 :label "My option"} {:key "my-key" :label "My Label"}]
           placeholder         ;; optional - placeholder text for input elem when value is empty
           ref-atom            ;; optional to control focus of dom-element
           hide-label?         ;; optional - hide label ? default false
           class-name          ;; optional - additional css class names
           show-tooltip-right? ;; optional - show tooltip - default is false
           field/tooltip-right ;; optional - tooltip text
           mandatory?          ;; optional - mandatory field default false
           drag-options        ;; optional - drag and move field handle see ....
           validate!           ;; optional - function to validate the entered value -> text return value is interpreted as error and is shown in the error area
           disabled?           ;; optional - default false
           read-only?          ;; optional - default false
           info-text           ;; optional - info text
           error-text          ;; optional - error text - controlled vs uncontrolled see :validate! param
           tools               ;; optional - enabled tool icons see ...
           secondary-view-args ;; optional - secondary input - f.e. currency has currency symbol select box as secondary input and number input as primary input type
           on-blur             ;; optional - input blur callback
           on-focus            ;; optional - input focus callback
           on-change           ;; optional - input value change callback
          ]}]                  ;; only mandatory params required by all editors listed here - additional optional params should be exposed here or documented as well
  (let [editor-atom (r/atom nil)
        local-atom (r/atom nil)]
    (r/create-class
     {:display-name   "input-editor"
      :reagent-render (fn [args]
                        (render local-atom
                                editor-atom
                                (merge args
                                       {:state-atom editor-atom})))})))
